<script>
import baseList from "@/views/components/base/baseList.vue";
import ImportTemplate from "@/views/components/common/form/deceiveTypeTemplate.vue";
let customerId = window.localStorage.getItem("customerId");
import config from "@/../config";

export default {
  extends: baseList,
  components: {
    ImportTemplate,
  },
  data() {
    return {
      table: {
        mname: "deciceClass",
        key: "id",
        url: {
          del: "/admin/system/facilityType",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "system/deviceClass/add",
        },
        {
          label: "导入分类",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          auth: "system/deviceClass/import",
          type: "info",
        },
        {
          label: "下载模板",
          icon: "md-log-out",
          onClick: this.toDownload,
          auth: "system/deviceClass/download",
          type: "info",
        },
        {
          label: "导出分类",
          icon: "md-download",
          type: "info",
          onClick: this.exportData.bind(this, "资产分类列表", 4),
          auth: "system/deviceClass/exportData",
        },
      ],
      menus: [],
      filters: [
        // { label: '时间选择', name: 'start_time', value: '', type: 'datetimerange' },
        {
          label: "资产分类",
          KeyEnter: this.search,
          name: "facilityName",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "资产分类",
          key: "facilityName",
          minWidth: 120,
          align: "left",
        },
        {
          title: "分类编号",
          key: "sigillum",
          minWidth: 120,
          align: "left",
        },
        {
          title: "创建时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "创建人",
          width: 120,
          align: "center",
          key: "createBy",
        },
        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: ["edit", "delete"],
          auth: {
            edit: "system/deviceClass/edit",
            del: "system/deviceClass/delete",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></ImportTemplate>
          );
        },
      });
    },
    toAdd() {
      $utils.url.push({ name: "deviceClass_add", query: { action: "add" } });
    },
    handleEdit(row) {
      let kv = row.id;
      $utils.url.push({
        name: "deviceClass_edit",
        query: { action: "edit", kv: kv },
      });
    },
    //下载模板
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/facilityType/template/download`;
    },
  },
};
</script>
<style scoped></style>
